
import styled from "styled-components"

export const ContainerEditor = styled.div`
    width: 90%;
    max-width: 820px;
    margin: 0 auto;
`;